module.exports = ".mat-dialog-content .mat-form-field {\n  width: 100%;\n}\n\n.cdk-overlay-container {\n  z-index: 1021;\n}\n\n.mat-dialog-container {\n  padding: 40px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/employees/employees.dialog.css
// module id = ./src/app/employees/employees.dialog.css
// module chunks = main